import L from 'leaflet';
import icon2x from 'leaflet/dist/images/marker-icon-2x.png';
import icon from 'leaflet/dist/images/marker-icon.png';
import shadow from 'leaflet/dist/images/marker-shadow.png';

export function ensureLeafletDefaultIcon() {
  const proto = L?.Icon?.Default?.prototype;
  const iconUrlProp = '_getIconUrl';
  if (proto?.[iconUrlProp]) delete proto[iconUrlProp];
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: icon2x,
    iconUrl: icon,
    shadowUrl: shadow,
  });
}

